module.exports = __webpack_public_path__ + "img/depto-min.7413095b.png";